var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { AgencyService } from '../common-theme/api/agency.service';
import { ActivatedRoute } from '@angular/router';
import { ApartmentTypesBaseComponent, ListTrackingService } from './../common-theme/index';
var BuildingsComponent = /** @class */ (function (_super) {
    __extends(BuildingsComponent, _super);
    function BuildingsComponent(injector, agencyService, route, window, listTrackingService, document) {
        var _this = _super.call(this, injector, agencyService, route, window, document) || this;
        _this.agencyService = agencyService;
        _this.route = route;
        _this.window = window;
        _this.listTrackingService = listTrackingService;
        _this.document = document;
        return _this;
    }
    BuildingsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.project = this.route.snapshot.data.project;
        this.setTitle(this.agencyService.agency.name, this.project.name);
        this.buildingFloors = this.route.snapshot.data.building_floors;
        if (this.project.name === 'B11') {
            this.setMetaDescription("Bloc Dream Residence - Ai la dispozitie un complex rezidential inclus intr-o oferta accesibila. Toate criteriile casei tale mult visate.");
        }
        if (this.project.name === 'B12') {
            this.setMetaDescription("Bloc de locuinte Dream Residence - Ai la dispozitie un complex rezidential inclus intr-o oferta accesibila. Toate criteriile casei tale mult visate.");
        }
        if (this.project.name === 'B12' || this.project.name === 'B13') {
            this.buildingFloors.sort(function (a, b) {
                if (a.floor_value > b.floor_value)
                    return -1;
                if (a.floor_value < b.floor_value)
                    return 1;
                return 0;
            });
            this.buildingFloors.push(this.buildingFloors.shift());
        }
        else if (this.project.name === 'B11') {
            this.buildingFloors = this.buildingFloors.reverse();
        }
    };
    return BuildingsComponent;
}(ApartmentTypesBaseComponent));
export { BuildingsComponent };



// WEBPACK FOOTER //
// ./src/app/buildings/buildings.component.ts.pre-build-optimizer.js